import { Dimensions, Sources } from 'components/insights/constants';
import PatientDrillInTable from 'components/insights/layout/details/PatientDrillInTable';

const LengthOfStayPatientTable = ({
  onSelectedDimensionsChange,
}: {
  onSelectedDimensionsChange: (selectedDimensions: Dimensions[]) => void;
}) => {
  return (
    <PatientDrillInTable
      title='Length of Stay by Patient'
      source={Sources.LOCATION_EPISODE_DISCHARGES}
      dataCy='losPatientDrillInTable'
      exportFilename='length-of-stay-by-patient-export'
      onSelectedDimensionsChange={onSelectedDimensionsChange}
      thirdColumn={{
        dimension: Dimensions.LENGTH_OF_STAY,
        header: 'Length of Stay',
        renderCell: (value: number) => `${value} days`,
        parseValue: (rawValue: any) => Number(rawValue) || 0,
      }}
    />
  );
};

export default LengthOfStayPatientTable;
